import { Report } from '@/app/models/costTracking';
import formatterMonetaryValue from './numberUtils';

const getReportValue = (reports: Report[], reportType: string): string => {
  const report = reports?.find(
    (item) => item.planningReportType === reportType || item.planningReportType === reportType,
  );
  if (!report) {
    return formatterMonetaryValue(0);
  }

  return formatterMonetaryValue(report.value);
};

export const getReportValueSecondary = (reports: Report[], reportType: string): string => {
  const report = reports?.find((item) => item.planningReportType === reportType);
  if (!report || report.valueSecondary == null) {
    return '';
  }

  return formatterMonetaryValue(report.valueSecondary);
};

export default getReportValue;
